import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useReactiveThemeProperty } from '../..';
export const Container = ({ children, style, ...rest }) => {
    const horizontalGutter = useReactiveThemeProperty('horizontalGutter');
    return (React.createElement(View, { style: StyleSheet.flatten([
            style,
            { paddingHorizontal: horizontalGutter },
        ]), ...rest }, children));
};
//# sourceMappingURL=Container.js.map